import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeParagraphs } from '../data/content';
export function Guarantee() {
  return <section className="w-full bg-white px-5 py-20 sm:py-24" data-id="element-111" data-mp="1o33y2s436cn1">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 text-center md:flex-row md:items-start md:gap-12 md:text-left" data-id="element-112" data-mp="223odrfepfscb">
        <div className="flex h-36 w-36 shrink-0 -rotate-6 flex-col items-center justify-center rounded-full border-[3px] border-ink bg-sun text-ink shadow-pop" data-id="element-113" data-mp="1x54pv9gjw6hb">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-114" data-mp="14gfn75zujt3g" />
          <span className="mt-1 font-display text-2xl font-black leading-none" data-id="element-115" data-mp="1j4k8mhqaaipx">
            7-DAY
          </span>
          <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.14em]" data-id="element-116" data-mp="1edbx9g5e8na4">
            Money-Back
          </span>
        </div>
        <div data-id="element-117" data-mp="qmybu8hbdmoi">
          <h2 className="font-display text-2xl font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-118" data-mp="qmexf1qvhgf8">
            Try CAREER READY™ With a 7-Day Money-Back Guarantee
          </h2>
          <div className="mt-5 space-y-3 text-base leading-relaxed text-ink-soft" data-id="element-119" data-mp="oz03pw3z42ou">
            {guaranteeParagraphs.map(paragraph => <p key={paragraph} data-id="element-120" data-mp="twi3avw3p5k6">{paragraph}</p>)}
            <p className="font-semibold text-ink" data-id="element-121" data-mp="yp2wbv76nemn">
              Explore the materials with the reassurance of our 7-day guarantee.
            </p>
          </div>
          
        </div>
      </div>
    </section>;
}